import styled from 'styled-components/macro';
import { ReactComponent as DropdownIconRaw } from 'assets/icons/dropdown-arrow.svg';

export const DropdownIcon = styled(DropdownIconRaw)<{ isOpen: boolean }>`
  transition: 0.3s;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'none')};
`;

export const Content = styled.div`
  min-width: 100vw;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Mask = styled.div`
  min-width: 100vw;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: transparent;
  z-index: 10;
`;

export const ContentWrapper = styled.div`
  background: white;
  display: flex;
  padding: 1rem;
  min-width: 50rem;
  flex-direction: column;
`;

export const Dropdown = styled.div<{ isError: boolean }>`
  z-index: 11;
  position: relative;
  min-height: 3.125rem;
  width: 100%;
  padding: 0 1.125rem;
  max-width: 50rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #c7cad1;
  border-radius: 4px;
  background-color: white;
  font-size: 1rem;
  color: #353531;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
`;

export const Placeholder = styled.span``;

export const CountryPill = styled.div`
  background-color: #477eeb;
  color: white !important;
  display: flex;
  margin-right: 0.5rem;
  padding: 5px 9px;
  border-radius: 2px;
  font-size: 0.875rem;
  margin: 4px;
  transition: 0.2s;
  align-items: center;
  white-space: nowrap;

  svg {
    margin-left: 0.5rem;
  }

  &:hover {
    background-color: #144bb8;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  position: absolute;
  top: 3.5rem;
  left: 0;
  padding: 0;
  width: 100%;
  max-height: 15rem;
  overflow-y: scroll;
`;

export const CountryList = styled.ul`
  list-style-type: none;
  max-height: 15rem;
  overflow-y: scroll;
  padding: 0;
  margin: 0;
`;

export const Checkbox = styled.div<{ isChecked?: boolean }>`
  width: 1.25rem;
  min-width: 1.25rem;
  height: 1.25rem;
  border: 1px solid ${({ isChecked }) => (isChecked ? 'none' : '#c7cad1')};
  border-radius: 2px;
  margin-right: 0.5rem;
  background-color: ${({ isChecked }) => (isChecked ? '#477eeb' : 'white')};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Label = styled.label`
  transition: 0.3s;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;

  &:hover {
    background: rgb(232, 239, 252);
  }
`;

export const Country = styled.li`
  font-size: 0.875rem;
`;

export const Pills = styled.div`
  display: flex;
  max-width: 40rem;
  overflow-y: scroll;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem;
  border: 1px solid rgb(199, 202, 209);
  border-radius: 4px;
  height: 2.5rem;
  min-height: 2.5rem;
  padding: 0px 0.5rem;
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  background: white;
  width: 100%;
`;

export const CountryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LanguageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 2rem;
`;

export const Language = styled.div`
  display: flex;
  align-items: center;
`;

export const Lang = styled.span``;
